(function() {
  'use strict';

  angular
    .module('blocks.queue', []);
})();
